import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { LaborProductsSearchControlComponent } from './products.labor-search.control.component';
import { ProductActionsComponent }             from './product.actions.component';
import { ProductBranchStockComponent }         from './product.branch-stock.component';
import { ProductsAdvancedSearchComponent }     from './products.advanced-search.component';
import { ProductsComponent }                   from './products.component';
import { ProductSearchService }                from './product.search.service';
import { ProductService }                      from './product.service';
import { ProductsService }                     from './products.service';
import { ProductsStates }                      from './products.states';
import { SharedModule }                        from '../shared/shared.module';
import { TableModule }                         from '../table/table.module';
import { VendorsModule }                       from '../vendors/vendors.module';

@NgModule({
  declarations: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductsAdvancedSearchComponent,
    ProductsComponent
  ],
  entryComponents: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductsAdvancedSearchComponent,
    ProductsComponent
  ],
  exports: [
    LaborProductsSearchControlComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    VendorsModule,

    UIRouterUpgradeModule.forChild({ states: ProductsStates })
  ],
  providers: [
    ProductSearchService,
    ProductService,
    ProductsService
  ]
})
export class ProductsModule {}
